/* eslint-disable no-restricted-globals */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import moment from 'moment';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import { displayPriceFormat } from '../../utils/tools';
import Paper from '../Paper';
import { mainColor } from '../../constants/theme';
import { SUITABLE_PAYMENT_TYPES, ORDER_CANCELED } from '../../constants';
import { calculateAge, getDateFormat } from '../../utils/suitableDate';
import { getOrderStatusLabel } from '../../utils/orderUtils';
import { styles } from './ClientModal.styles';
import Spinner from '../Spinner';
import { handleChangeOrderPage, handleChangeReductionPage } from './ClientModal.service';

class ClientModal extends Component {
  state = {
    page: 0,
    rowsPerPage: 5,
    reductionPage: 0,
    reductionRowsPerPage: 1,
    currentClientOrders: null,
    promotions: []
  };

  async componentWillMount() {
    const { client } = this.props;
    const { promotions = {}, billing } = client;
    this.setState({
      promotions,
      currentClientOrders: _.orderBy(
        billing,
        [
          bill => {
            return moment(bill.date);
          },
          'orderNumber'
        ],
        ['desc', 'desc']
      ).filter(order => order.chargeId)
    });
  }

  displayOrderDetail = ({ title, body, color }) => {
    const { classes } = this.props;
    return (
      <div className='mb-2'>
        <p className={classes.orderDetail}>
          {' '}
          {title} <b style={{ color, fontSize: '18px', margin: '0px 0px 0px 5px' }}> {body} </b>
        </p>
      </div>
    );
  };

  createTableRow = () => {
    const { classes } = this.props;
    const { currentClientOrders } = this.state;
    const currRecords = currentClientOrders.slice(
      this.state.page * this.state.rowsPerPage,
      this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
    );

    return (
      <TableBody>
        {currRecords.map(e => {
          const { dateOrder, orderNumber, status, paymentType, priceOrder = 0, cancellation } = e;
          return (
            <TableRow key={orderNumber}>
              <TableCell align='center' className={classes.orderRow}>
                {orderNumber || '--'}
              </TableCell>
              <TableCell align='center' className={classes.orderRow}>
                {getDateFormat(dateOrder || '--', 'DD/MM/YYYY')}
              </TableCell>
              <TableCell align='center' className={classes.orderRow}>
                {SUITABLE_PAYMENT_TYPES[paymentType] || '--'}
              </TableCell>
              <TableCell align='center' className={classes.orderRow}>
                {getOrderStatusLabel(cancellation ? ORDER_CANCELED : status || '--')}
              </TableCell>
              <TableCell align='center' className={classes.orderRow}>
                {displayPriceFormat(priceOrder) || `0 €`}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  };

  createReductionTableRow = () => {
    const { classes } = this.props;
    const currRecords = this.state.promotions.slice(
      this.state.reductionPage * this.state.reductionRowsPerPage,
      this.state.reductionPage * this.state.reductionRowsPerPage + this.state.reductionRowsPerPage
    );
    return (
      <TableBody>
        {currRecords.map(e => {
          const { date, promotion = {}, status } = e;
          return (
            <TableRow key={e.id}>
              <TableCell align='center' className={classes.orderRow}>
                {promotion.promoCode}
              </TableCell>
              <TableCell align='center' className={classes.orderRow}>
                {!isNaN(promotion.type)
                  ? displayPriceFormat(promotion.type)
                  : promotion.type === 'delivery_free'
                    ? 'Livraison gratuite'
                    : promotion.type}
              </TableCell>
              <TableCell align='center' className={classes.orderRow}>
                {status}
              </TableCell>
              <TableCell align='center' className={classes.orderRow}>
                {getDateFormat(date, 'DD/MM/YYYY')}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  };

  createTableHead = list => {
    const { classes } = this.props;
    return (
      <TableHead>
        <TableRow style={{ height: 40 }}>
          {list.map(e => {
            return (
              <TableCell key={e} align='center' className={classes.heading}>
                {e}
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    );
  };

  render() {
    const { classes, client } = this.props;
    const { currentClientOrders, page, rowsPerPage } = this.state;
    const {
      email,
      number,
      birthDate,
      firstName,
      nbTransaction,
      totalMoneySpent,
      nbTransactionCanceled = 0,
      promotions,
      lastName
    } = client;
    const totalTransactions = nbTransactionCanceled + nbTransaction;

    const reductionTabHead = promotions.length
      ? ['Code', 'Valeur', 'Statut', `Date d'activation`]
      : [];
    const ordersTabHead =
      currentClientOrders && currentClientOrders.length
        ? ['Commande', 'Date', 'Paiement', 'État', 'Total payé']
        : [];

    return (
      <div>
        <div className='row pl-3'>
          <div className='col'>
            {this.displayOrderDetail({
              title: 'NOMBRE DE COMMANDES :',
              body: totalTransactions || 0
            })}
            {this.displayOrderDetail({
              title: 'Total payé :',
              color: mainColor.colorRed,
              body: displayPriceFormat(totalMoneySpent)
            })}
          </div>
        </div>
        <div className='row p-2'>
          <div className='col-sm p-2'>
            <Paper className={classes.paperStyle}>
              <div className={classes.detail}>
                <p className={classes.subtitle}>INFORMATIONS CLIENT</p>
                <hr className={classes.hrStyle} />

                <div>
                  <p className={classes.typoDetails}>
                    {' '}
                    <p className={classes.labelStyle}>Prénom :</p>
                    {`${firstName || '--'}`}{' '}
                  </p>
                </div>
                {lastName ? (
                  <div>
                    <p className={classes.typoDetails}>
                      {' '}
                      <p className={classes.labelStyle}>Nom :</p>
                      {`${lastName || '--'}`}
                    </p>
                  </div>
                ) : null}
                <div>
                  <p className={classes.typoDetails}>
                    <p className={classes.labelStyle}>Age :</p>
                    {birthDate
                      ? `${calculateAge(birthDate)} ans (date de naissance ${birthDate}))`
                      : 'Non défini'}
                  </p>
                </div>
                <div>
                  <p className={classes.typoDetails}>
                    {' '}
                    <p className={classes.labelStyle}>Email :</p>
                    {`${email || '--'}`}
                  </p>
                </div>
                <div>
                  <p className={classes.typoDetails}>
                    <p className={classes.labelStyle}>Numéro :</p>
                    {`${number || '--'}`}
                  </p>
                </div>
              </div>
            </Paper>
          </div>

          <div className='col-sm p-2'>
            <Paper className={classes.paperStyle} scrollOption='auto'>
              <div className={classes.detail}>
                <p className={classes.subtitle}>CODE(S) PROMOTIONNEL(S)</p>
                <hr className={classes.hrStyle} />
                {reductionTabHead.length ? (
                  <Paper elevation={0} scrollOption='auto' style={{ padding: 0 }}>
                    <Table className={classes.table}>
                      {this.createTableHead(reductionTabHead)}
                      {this.createReductionTableRow()}
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[]}
                      component='div'
                      labelRowsPerPage='Lignes par page'
                      count={this.state.promotions.length}
                      page={this.state.reductionPage}
                      rowsPerPage={this.state.reductionRowsPerPage}
                      onChangePage={(event, page) => handleChangeReductionPage(event, page, this)}
                    />
                  </Paper>
                ) : (
                  <p className={classes.detail} style={{ textAlign: 'center' }}>
                    {`${firstName} ne possède aucun code promotionnel. `}
                  </p>
                )}
              </div>
            </Paper>
          </div>
        </div>

        <div className='row'>
          <div className='col-sm'>
            <Paper className={classes.paperStyle} scrollOption='auto'>
              <div className={classes.detail}>
                <p className={classes.subtitle}>HISTORIQUE DES COMMANDES</p>
                <hr className={classes.hrStyle} />
                {!currentClientOrders && (
                  <center className='mt-4'>
                    <Spinner size={30} />
                  </center>
                )}
                {currentClientOrders &&
                  (currentClientOrders.length ? (
                    <>
                      <div className={classes.rowTitle}>
                        <p style={{ marginRight: 20, display: 'inline-block' }}>
                          Commandes terminées : <b> {nbTransaction || 0}</b>
                        </p>
                        <p style={{ display: 'inline-block' }}>
                          Commandes annulées : <b>{nbTransactionCanceled || 0}</b>
                        </p>
                      </div>
                      <Paper elevation={0} scrollOption='auto'>
                        <Table className={classes.table}>
                          {this.createTableHead(ordersTabHead)}
                          {this.createTableRow()}
                        </Table>
                        <TablePagination
                          rowsPerPageOptions={[]}
                          component='div'
                          labelRowsPerPage='Lignes par page'
                          count={currentClientOrders.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onChangePage={(event, page) => handleChangeOrderPage(event, page, this)}
                        />
                      </Paper>
                    </>
                  ) : (
                    <p className={classes.detail} style={{ textAlign: 'center' }}>
                      {`${firstName} ne possède aucune commande. `}
                    </p>
                  ))}
              </div>
            </Paper>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(ClientModal);
